import { apiEndPoints } from "utils/api-endpoints";
import HTTPService from "utils/httpService";

export const deleteMemberById = (params: string) => {
  return HTTPService.delete(apiEndPoints.members + "/" + params, {});
};
